import { useEffect, useState } from 'react';
import { JoveChatMessageSenderRoleEnum } from '@jove-frontend/enums';
import { ChatMessagePositionEnum } from '@jove-frontend/types';
import { AccountCircleOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { formatChatTimeDisplay } from '../../../utils/time';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ChatMessageCardWrapperView = function ChatMessageCardWrapperView(props) {
  var className = props.className,
      message = props.message,
      children = props.children;

  var _useState = useState(''),
      userName = _useState[0],
      setUserName = _useState[1];

  var _useState2 = useState(null),
      userIcon = _useState2[0],
      setUserIcon = _useState2[1];
  /**
   * methods
   */


  useEffect(function () {
    var _message$sender, _message$sender2, _message$sender3, _message$sender4, _message$sender5, _message$sender6;

    if (message) {
      var _userName = '';
      var _userIcon = null;

      switch (message.senderRole) {
        case JoveChatMessageSenderRoleEnum.agent:
          _userName = ((_message$sender = message.sender) === null || _message$sender === void 0 ? void 0 : _message$sender.name) || 'Jove Customer Service';
          _userIcon = /*#__PURE__*/_jsx("img", {
            src: ((_message$sender2 = message.sender) === null || _message$sender2 === void 0 ? void 0 : _message$sender2.avatar) || 'https://storage.googleapis.com/jove-public-images/ai/agent-avatar.png',
            className: "h-10 w-10 rounded-full object-cover",
            alt: "AI avatar"
          }, _userIcon);
          break;

        case JoveChatMessageSenderRoleEnum.customer:
          _userName = ((_message$sender3 = message.sender) === null || _message$sender3 === void 0 ? void 0 : _message$sender3.name) || 'Customer';
          _userIcon = /*#__PURE__*/_jsx(AccountCircleOutlined, {
            className: "h-10 w-10 text-[#2563EB]"
          });
          break;

        case JoveChatMessageSenderRoleEnum.whatsapp:
          _userName = (_message$sender4 = message.sender) !== null && _message$sender4 !== void 0 && _message$sender4.name ? "WhatsApp: ".concat((_message$sender5 = message.sender) === null || _message$sender5 === void 0 ? void 0 : _message$sender5.name) : 'WhatsApp User';
          _userIcon = /*#__PURE__*/_jsx("img", {
            src: ((_message$sender6 = message.sender) === null || _message$sender6 === void 0 ? void 0 : _message$sender6.avatar) || 'https://storage.googleapis.com/jove-public-images/ai/whatsapp-avatar.jpg',
            className: "h-10 w-10 rounded-full object-cover",
            alt: "AI avatar"
          }, _userIcon);
          break;

        case JoveChatMessageSenderRoleEnum.ai:
          _userName = 'Mia';
          _userIcon = /*#__PURE__*/_jsx("img", {
            src: "https://storage.googleapis.com/jove-public-images/ai/ai-avatar.png",
            className: "h-10 w-10 rounded-full object-cover",
            alt: "AI avatar"
          }, _userIcon);
          break;
      }

      setUserName(_userName);
      setUserIcon(_userIcon);
    }
  }, [message]);

  if (!message) {
    return null;
  }

  return /*#__PURE__*/_jsxs(Box, {
    className: clsx('flex flex-row space-x-2', message.position === ChatMessagePositionEnum.right ? 'justify-end' : 'justify-start', className),
    children: [message.position === ChatMessagePositionEnum.left && !!userIcon ? userIcon : null, /*#__PURE__*/_jsxs(Box, {
      className: clsx('flex max-w-[85%] flex-col space-y-1', message.position === ChatMessagePositionEnum.right ? 'items-end' : 'items-start'),
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        className: "font-medium leading-3 text-[#707070]",
        children: userName
      }), /*#__PURE__*/_jsx(Box, {
        className: clsx('flex w-fit max-w-full flex-col space-y-3 rounded-lg px-4 py-3 shadow-sm', message.position === ChatMessagePositionEnum.right ? 'bg-white text-[#202020]' : 'bg-[#EBEFFE] text-[#0E35D1]'),
        children: children
      }), message.created_at ? /*#__PURE__*/_jsx(Typography, {
        variant: "caption",
        className: "leading-3 text-[#9A9A9A]",
        children: formatChatTimeDisplay(message.created_at)
      }) : null]
    }), message.position === ChatMessagePositionEnum.right && !!userIcon ? userIcon : null]
  }, message.id);
};

export default ChatMessageCardWrapperView;